module.exports = __webpack_public_path__ + "static/ie11map-2d5b26ac3c96e88569e109443d4d072e.png";